import React from 'react'

interface WizardProgressBarProps {
  totalSteps: number
  currentStep: number // 0-indexed
}

const WizardProgressBar = ({ totalSteps, currentStep }: WizardProgressBarProps) => (
  <div style={{ display: 'flex', gap: '4px', width: '100%' }}>
    {Array.from({ length: totalSteps }).map((_, i) => (
      <div
        key={i}
        style={{
          height: '3px',
          flex: 1,
          borderRadius: '9999px',
          backgroundColor: i <= currentStep ? '#2196F3' : '#e5e7eb',
          transition: 'background-color 0.2s',
        }}
      />
    ))}
  </div>
)

export default WizardProgressBar
